import React, { ReactNode, useState } from "react";
import "../css/ExpandableView.css";
import collapsedArrowIcon from "../../assets/images/profile-collapsed-arrow-icon.svg";

interface ExpandableViewProps {
  title: string;
  subTitle: string;
  children: ReactNode;
}

const ExpandableView: React.FC<ExpandableViewProps> = ({
  title,
  subTitle,
  children,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        className="expandable-view-details-container"
        onClick={() => setExpanded((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        <span>
          {title} <span style={{ color: "#C2B58C" }}>{subTitle}</span>
        </span>
        <div className="expandable-view-expand-container">
          <img
            src={collapsedArrowIcon}
            alt="collapsed-arrow-icon"
            style={{
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s",
            }}
          />
        </div>
      </div>
      {expanded && (
        <div className="expandable-view-details-content">{children}</div>
      )}
    </div>
  );
};

export default ExpandableView;